import { render, staticRenderFns } from "./resultPacsList.vue?vue&type=template&id=5aa30148&scoped=true&"
import script from "./resultPacsList.vue?vue&type=script&lang=js&"
export * from "./resultPacsList.vue?vue&type=script&lang=js&"
import style0 from "./resultPacsList.vue?vue&type=style&index=0&id=5aa30148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa30148",
  null
  
)

export default component.exports